// libs
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

// selectors
import { onIntlNetwork as _onIntlNetwork } from 'shared/store/app/selectors';

// components
import LoginNudge from './LoginNudge';

// types
import { ILoginNudge } from './types';

const Container = ({ children, page }: ILoginNudge) => {
  const onIntlNetwork = useSelector(_onIntlNetwork);

  if (onIntlNetwork) return <>{children}</>;

  return <LoginNudge page={page}>{children}</LoginNudge>;
};

export default memo(Container);
